import { EventEmitter, Injectable, Optional } from '@angular/core';
import { FirebaseAnalyticsUtilLibService } from '@b2b/firebase-analytics-util-lib';
import { GoogleTagManagerService } from '@b2b/web-google-analytics-lib';
import { environment } from '@src/environments/environment'; // import { LoggerService } from '@app/services/util-services/logger.service';
import { ContainerModel } from '@app/models/server/layout.model';
import { OrderResponseModel } from '@app/models/client/order-request.model';

const WEB_BOOKING_CONFIRMATION: string = String('booking_confirmation');
const APP_BOOKING_CONFIRMATION: string = String('app_bookings');

@Injectable({ providedIn: 'root' })
export class AnalyticsEventService {
  fireAnalyticsEvent: EventEmitter<{ eventName: string; data: any }> =
    new EventEmitter<any>();

  /*fireRegistrationEvent: EventEmitter<{
    eventName: string;
    data: any;
    platform: string;
  }> = new EventEmitter<any>();*/

  fireCartContainerEvent: EventEmitter<{
    eventName: string;
    cartContainer: ContainerModel[];
  }> = new EventEmitter<any>();

  fireBookingConfirmationEvent: EventEmitter<{
    orderResponse: OrderResponseModel;
  }> = new EventEmitter<any>();

  constructor(
    @Optional()
    private firebaseAnalyticsUtilLibService: FirebaseAnalyticsUtilLibService,
    @Optional()
    private googleTagManagerService: GoogleTagManagerService,
  ) {
    this.fireAnalyticsEvent.subscribe({
      next: (result: { eventName: string; data: any }) => {
        this.fireEvent(result?.eventName, result?.data);
      },
    });

    this.fireCartContainerEvent.subscribe({
      next: (result: {
        eventName: string;
        cartContainer: ContainerModel[];
      }) => {
        this.cartContainerEvent(result?.eventName, result?.cartContainer);
      },
    });

    this.fireBookingConfirmationEvent.subscribe({
      next: (result: { orderResponse: OrderResponseModel }) => {
        this.fireBookingSuccessEvent(result?.orderResponse);
      },
    });
  }

  setScreenName(url: string) {
    // LoggerService.warn('Inside setScreenName url is ', url);
    if (environment?.webApp) {
      this.googleTagManagerService?.setScreenName(url);
    } else {
      this.firebaseAnalyticsUtilLibService?.setScreenName(url);
    }
  }

  fireSearchEvent(featureType: string, pageType: string, data: any) {
    // LoggerService.warn(
    //   'Inside fireSearchEvent featureType is ',
    //   featureType,
    //   pageType
    // );
    let eventName: string = String('search');
    if (featureType) {
      eventName = eventName + '_' + featureType.toLowerCase();
    }
    if (pageType) {
      eventName = eventName + '_' + pageType.toLowerCase();
    }

    // LoggerService.warn('Inside fireSearchEvent eventName is ', eventName);

    if (environment?.webApp) {
      this.googleTagManagerService?.fireEvent(eventName, data);
    } else {
      this.firebaseAnalyticsUtilLibService?.fireEvent(eventName, data);
    }
  }

  fireTextSearch(value: string, featureType?: string) {
    // LoggerService.warn('Inside fireTextSearch value is ', value);
    let eventName: string = String('text_search');
    if (featureType) {
      eventName = eventName + '_' + featureType.toLowerCase();
    }

    if (environment?.webApp) {
      this.googleTagManagerService?.fireEvent(eventName, value);
    } else {
      this.firebaseAnalyticsUtilLibService?.fireEvent(eventName, value);
    }
  }

  private fireEvent(eventName: string, data: any) {
    if (environment?.webApp) {
      this.googleTagManagerService?.fireEvent(eventName, data);
    } else {
      this.firebaseAnalyticsUtilLibService?.fireEvent(eventName, data);
    }
  }

  private fireBookingSuccessEvent(data: OrderResponseModel) {
    // LoggerService.warn(
    //   'Inside fireBookingSuccessEvent eventName is ',
    //   eventName
    // );

    if (environment?.webApp) {
      this.googleTagManagerService?.fireBookingEvent(
        WEB_BOOKING_CONFIRMATION,
        data,
      );
    } else {
      this.firebaseAnalyticsUtilLibService?.fireBookingEvent(
        APP_BOOKING_CONFIRMATION,
        data,
      );
    }
  }

  cartContainerEvent(eventName: string, cartContainers: ContainerModel[]) {
    // LoggerService.warn(
    //   'Inside cartContainerEvent eventName is ',
    //   eventName,
    //   cartContainers
    // );

    let type: string;
    const data: { name: string }[] = [];

    for (const cartContainer of cartContainers) {
      type = cartContainer?.feature?.type;
      if (cartContainer?.data?.length > 0) {
        for (const containerItem of cartContainer?.data) {
          data.push({ name: containerItem?.title });
        }
      }
      if (cartContainer?.containers?.length > 0) {
        for (const containerItem of cartContainer?.containers) {
          data.push({ name: containerItem?.title });
        }
      }
    }

    if (type) {
      eventName = eventName + '_' + type.toLowerCase();
    }

    if (environment?.webApp) {
      this.googleTagManagerService?.fireEvent(eventName, data);
    } else {
      this.firebaseAnalyticsUtilLibService?.fireEvent(eventName, data);
    }
  }

  registrationEvent(result: { data: any; platform: string }) {
    if (environment?.webApp) {
      this.fireEvent('registration_web', result?.data);
    } else {
      if (result?.platform === 'android') {
        this.fireEvent('registration_android', result?.data);
      } else {
        this.fireEvent('registration_ios', result?.data);
      }
    }
  }
}
